import React from 'react';

/**
 * Treść Polityki prywatności Documaster Globalservice, wersja 1.0.
 * Tekst pochodzi z działu prawnego. Zmiany treści uzgadniać z działem prawnym.
 * Sekcja 12 opisuje ciasteczka faktycznie używane przez konsolę (patrz SessionContextProvider.js).
 */
const PrivacyPolicyContent = () => <>
  <h2>Polityka prywatności Documaster Globalservice</h2>
  <p className="legal-version">Wersja 1.0</p>

  <h3>1. Informacje ogólne</h3>
  <p>Niniejsza Polityka prywatności określa zasady przetwarzania danych związanych z korzystaniem z systemu Documaster Globalservice.</p>
  <p>Producentem i operatorem systemu oraz podmiotem utrzymującym infrastrukturę serwerową, na której przechowywane są dane Documaster Globalservice, jest:</p>
  <p>
    Euroimpex S.A.<br/>
    ul. Mydlana 3B<br/>
    51-502 Wrocław<br/>
    dalej: „Euroimpex”.
  </p>
  <p>Documaster Globalservice jest systemem zdalnego monitorowania, ewidencji i raportowania urządzeń wielofunkcyjnych Ricoh.</p>

  <h3>2. Rola Euroimpex w przetwarzaniu danych</h3>
  <p>W zależności od rodzaju danych i okoliczności ich przetwarzania Euroimpex może występować w różnych rolach wynikających z przepisów o ochronie danych osobowych.</p>
  <p>W odniesieniu do danych niezbędnych do prowadzenia i zabezpieczenia własnej usługi, obsługi kontaktów z klientami, realizacji obowiązków prawnych oraz zapewnienia bezpieczeństwa infrastruktury Euroimpex może występować jako administrator danych.</p>
  <p>W odniesieniu do danych osobowych powierzonych Euroimpex przez klienta w związku z korzystaniem z Documaster Globalservice Euroimpex może występować jako podmiot przetwarzający dane w imieniu klienta, natomiast klient pozostaje administratorem tych danych.</p>
  <p>Szczegółowe zasady takiego przetwarzania powinny zostać określone w umowie zawartej z klientem, w tym – gdy jest to wymagane – w umowie powierzenia przetwarzania danych osobowych.</p>

  <h3>3. Jakie informacje przetwarza Documaster Globalservice</h3>
  <h4>Dane dotyczące urządzeń</h4>
  <p>System może przetwarzać między innymi:</p>
  <ul>
    <li>nazwę urządzenia;</li>
    <li>numer seryjny;</li>
    <li>NIS;</li>
    <li>model;</li>
    <li>adres IP;</li>
    <li>adres MAC;</li>
    <li>lokalizację;</li>
    <li>opis;</li>
    <li>pola własne;</li>
    <li>stan urządzenia;</li>
    <li>liczniki;</li>
    <li>poziomy materiałów eksploatacyjnych;</li>
    <li>zdarzenia i błędy;</li>
    <li>historię stanów;</li>
    <li>informacje dotyczące wymian materiałów;</li>
    <li>znaczniki czasu komunikacji.</li>
  </ul>
  <p>Zakres danych technicznych wynika z funkcjonalności Systemu.</p>
  <h4>Dane dotyczące użytkowników</h4>
  <p>W związku z obsługą kont System może przetwarzać w szczególności:</p>
  <ul>
    <li>adres e-mail;</li>
    <li>dane niezbędne do identyfikacji konta;</li>
    <li>przypisaną rolę;</li>
    <li>imię;</li>
    <li>nazwisko;</li>
    <li>przypisane lokalizacje.</li>
  </ul>

  <h3>4. Dane o wydrukach i dokumentach</h3>
  <p>Documaster Globalservice nie jest systemem zarządzania drukiem ani serwerem wydruku i nie przejmuje obsługi kolejek wydruku.</p>
  <p>W zakresie opisanym w dokumentacji produktu System gromadzi dane dotyczące urządzeń, ich stanu, liczników, materiałów i zdarzeń, a nie treść drukowanych lub skanowanych dokumentów.</p>

  <h3>5. Cele przetwarzania</h3>
  <p>Dane mogą być przetwarzane w celu:</p>
  <ul>
    <li>świadczenia usługi Documaster Globalservice;</li>
    <li>prowadzenia kont użytkowników;</li>
    <li>uwierzytelniania i kontroli dostępu;</li>
    <li>monitorowania urządzeń;</li>
    <li>prowadzenia ewidencji floty;</li>
    <li>prezentowania liczników;</li>
    <li>monitorowania materiałów eksploatacyjnych;</li>
    <li>obsługi informacji i zdarzeń serwisowych;</li>
    <li>generowania raportów;</li>
    <li>wysyłania skonfigurowanych powiadomień;</li>
    <li>zapewnienia bezpieczeństwa Systemu;</li>
    <li>diagnozowania błędów i awarii;</li>
    <li>wykonywania obowiązków wynikających z zawartych umów i przepisów prawa.</li>
  </ul>

  <h3>6. Podstawy prawne przetwarzania danych osobowych</h3>
  <p>W przypadkach, w których Euroimpex występuje jako administrator danych, podstawą przetwarzania może być w szczególności:</p>
  <ul>
    <li>art. 6 ust. 1 lit. b RODO – gdy przetwarzanie jest niezbędne do wykonania umowy lub podjęcia działań przed jej zawarciem;</li>
    <li>art. 6 ust. 1 lit. c RODO – gdy przetwarzanie jest niezbędne do wykonania obowiązku prawnego;</li>
    <li>art. 6 ust. 1 lit. f RODO – w zakresie prawnie uzasadnionych interesów Euroimpex, takich jak zapewnienie bezpieczeństwa Systemu, ochrona przed nadużyciami, ustalanie lub obrona roszczeń oraz zapewnienie prawidłowego funkcjonowania usługi.</li>
  </ul>
  <p>W przypadkach, w których Euroimpex działa jako podmiot przetwarzający, dane przetwarzane są na udokumentowane polecenie klienta będącego administratorem danych oraz na zasadach określonych w zawartej umowie.</p>

  <h3>7. Gdzie przechowywane są dane</h3>
  <p>Dane Documaster Globalservice są fizycznie przechowywane w infrastrukturze serwerowej wykorzystywanej przez Euroimpex S.A na terenie Polski.</p>
  <p>Dostęp do danych posiadają wyłącznie osoby lub podmioty posiadające odpowiednie uprawnienia i wyłącznie w zakresie niezbędnym do wykonywania powierzonych zadań.</p>

  <h3>8. Odbiorcy danych</h3>
  <p>Dane mogą być udostępniane:</p>
  <ul>
    <li>uprawnionym pracownikom i współpracownikom Euroimpex;</li>
    <li>administratorom i użytkownikom klienta zgodnie z nadanymi uprawnieniami;</li>
    <li>dostawcom infrastruktury lub usług wykorzystywanych do świadczenia usługi – jeżeli tacy występują;</li>
    <li>podmiotom świadczącym usługi serwisowe lub IT na rzecz Euroimpex – jeżeli jest to niezbędne;</li>
    <li>organom publicznym, jeżeli obowiązek przekazania danych wynika z przepisów prawa.</li>
  </ul>
  <p>Podmioty otrzymujące dostęp do danych zobowiązane są do zachowania odpowiedniej poufności i bezpieczeństwa zgodnie z charakterem świadczonych usług i obowiązującymi przepisami.</p>

  <h3>9. Okres przechowywania danych</h3>
  <p>Dane przechowywane są przez okres niezbędny do świadczenia usługi oraz realizacji celów, dla których zostały zgromadzone.</p>
  <p>Okres przechowywania poszczególnych kategorii danych może być różny.</p>
  <p>Dokumentacja produktu wskazuje przykładowo, że historia wymian materiałów eksploatacyjnych prezentowana jest w konsoli za okres ostatnich 12 miesięcy. Nie przesądza to jednak samo w sobie o okresie fizycznego przechowywania danych w bazie Systemu.</p>
  <p>Po zakończeniu świadczenia usługi dane mogą być przechowywane przez okres niezbędny do wykonania obowiązków prawnych, rozliczenia umowy oraz ustalenia, dochodzenia lub obrony roszczeń, a następnie usuwane lub anonimizowane zgodnie z obowiązującymi zasadami retencji.</p>

  <h3>10. Bezpieczeństwo danych</h3>
  <p>Euroimpex stosuje środki techniczne i organizacyjne mające na celu zapewnienie poziomu bezpieczeństwa odpowiedniego do charakteru przetwarzanych informacji.</p>
  <p>W szczególności dostęp do danych w konsoli WWW jest ograniczony do uprawnionych użytkowników. Sama architektura produktu przewiduje centralne przechowywanie danych i prezentowanie ich uprawnionym użytkownikom.</p>
  <p>Użytkownicy zobowiązani są do ochrony danych uwierzytelniających i nieudostępniania swoich kont osobom trzecim.</p>

  <h3>11. Prawa osób, których dane dotyczą</h3>
  <p>Jeżeli Euroimpex jest administratorem danych osobowych, osobie, której dane dotyczą, mogą przysługiwać – stosownie do okoliczności i podstawy prawnej przetwarzania – prawa wynikające z RODO, w szczególności prawo:</p>
  <ul>
    <li>dostępu do danych;</li>
    <li>sprostowania danych;</li>
    <li>usunięcia danych;</li>
    <li>ograniczenia przetwarzania;</li>
    <li>przenoszenia danych;</li>
    <li>wniesienia sprzeciwu wobec przetwarzania.</li>
  </ul>
  <p>Jeżeli Euroimpex przetwarza dane wyłącznie jako podmiot przetwarzający na rzecz klienta, żądanie dotyczące realizacji praw osoby powinno być kierowane w pierwszej kolejności do administratora danych, którym jest właściwy klient.</p>
  <p>Osobie, której dane dotyczą, przysługuje również prawo wniesienia skargi do Prezesa Urzędu Ochrony Danych Osobowych, jeżeli uważa, że jej dane osobowe są przetwarzane niezgodnie z przepisami.</p>

  <h3>12. Pliki cookies</h3>
  <p>Konsola WWW Documaster Globalservice wykorzystuje wyłącznie pliki cookies niezbędne do jej działania. Nie stosuje cookies analitycznych, reklamowych ani pochodzących od podmiotów trzecich.</p>
  <p>Konsola zapisuje w przeglądarce:</p>
  <ul>
    <li>identyfikator sesji połączenia z serwerem, ustawiany przy pierwszym wejściu do konsoli i niezbędny do utrzymania połączenia oraz uwierzytelnienia; przechowywany do zamknięcia przeglądarki;</li>
    <li>identyfikator zalogowanego użytkownika, ustawiany po zalogowaniu, dzięki któremu nie trzeba logować się ponownie przy kolejnych wizytach; przechowywany do zamknięcia przeglądarki, a po zaznaczeniu opcji „Zapamiętaj mnie” przez 14 dni.</li>
  </ul>
  <p>Cookies te są konieczne do świadczenia usługi żądanej przez użytkownika, to jest zalogowania i korzystania z konsoli. Zgodnie z art. 399 ust. 3 ustawy z dnia 12 lipca 2024 r. Prawo komunikacji elektronicznej ich stosowanie nie wymaga zgody użytkownika.</p>
  <p>Użytkownik może usunąć cookies lub zablokować ich zapisywanie w ustawieniach przeglądarki. Zablokowanie cookies uniemożliwi zalogowanie do konsoli.</p>

  <h3>13. Zautomatyzowane podejmowanie decyzji</h3>
  <p>Na podstawie dostarczonego opisu funkcjonalnego Documaster Globalservice służy do monitorowania, ewidencji, raportowania i obsługi informacji serwisowych. Dokumentacja nie wskazuje na podejmowanie wobec użytkowników decyzji wywołujących skutki prawne w sposób wyłącznie zautomatyzowany.</p>

  <h3>14. Kontakt w sprawach dotyczących prywatności</h3>
  <p>W sprawach związanych z ochroną danych oraz działaniem Documaster Globalservice można kontaktować się z:</p>
  <p>
    Euroimpex S.A.<br/>
    ul. Mydlana 3B<br/>
    51-502 Wrocław
  </p>
  <p>E-mail dotyczący ochrony danych: helpdesk@euroimpex.pl</p>
  <p>Inspektor Ochrony Danych: Barbara Pokorny</p>

  <h3>15. Zmiany Polityki prywatności</h3>
  <p>Polityka może być aktualizowana w związku ze zmianami funkcjonalności Documaster Globalservice, infrastruktury technicznej, sposobu przetwarzania danych lub obowiązujących przepisów.</p>
  <p>Aktualna wersja Polityki może być udostępniana użytkownikom za pośrednictwem Systemu.</p>
  <p className="legal-version">Wersja: 1.0<br/>Data obowiązywania: 01.09.2026</p>
</>;

export default PrivacyPolicyContent;
